var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeeve(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16533_52178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0H560C582.091 0 600 17.9086 600 40V560C600 582.091 582.091 600 560 600H40C17.9086 600 0 582.091 0 560V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16533_52178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.588 290.802L153.125 229.034V186.807L251.639 249.587L251.588 290.802Z",
    fill: "url(#paint0_linear_16533_52178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.132 352.157L54.8203 290.596V247.859L153.132 309.929V352.157Z",
    fill: "url(#paint1_linear_16533_52178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8203 352.666L153.132 412.192V369.965L54.8203 309.93V352.666Z",
    fill: "url(#paint2_linear_16533_52178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.125 291.105L251.639 350.86V310.076L153.125 248.877V291.105Z",
    fill: "url(#paint3_linear_16533_52178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.132 291.105L54.8203 352.666V309.929L153.132 248.877V291.105Z",
    fill: "#FFD23B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.639 290.829L153.125 352.157V309.929L251.639 249.793V290.829Z",
    fill: "#A2ECE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.132 229.034L54.8203 290.595V247.859L153.132 186.807V229.034Z",
    fill: "#FFD23B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.639 350.86L153.125 412.188V369.96L251.639 310.076V350.86Z",
    fill: "#A2ECE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.039 324.429L273.008 275.635H287.804L296.425 306.04H296.636L307.601 275.951H314.305L325.059 306.04H325.27L333.987 275.635H348.669L331.656 324.429H322.077L311.01 295.514H310.799L299.623 324.429H290.039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82 301.786V302.423C360.82 309.971 365.931 314.755 372.85 314.755C377.64 314.755 381.15 312.308 383.916 308.06L384.77 307.739L395.946 312.102C391.473 320.607 383.494 325.391 372.423 325.391C356.563 325.391 346.336 314.544 346.336 299.555C346.336 284.35 356.888 273.613 372.093 273.613C386.889 273.613 397.212 283.608 397.212 299.66C397.22 300.37 397.185 301.08 397.107 301.786H360.82ZM361.031 294.344H383.054C382.627 287.645 378.466 283.713 372.304 283.713C366.353 283.713 361.885 287.539 361.018 294.344H361.031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.769 301.786V302.423C412.769 309.97 417.875 314.754 424.794 314.754C429.584 314.754 433.098 312.307 435.865 308.059L436.714 307.738L447.89 312.101C443.421 320.606 435.438 325.39 424.367 325.39C408.511 325.39 398.289 314.548 398.289 299.559C398.289 284.354 408.842 273.617 424.051 273.617C438.847 273.617 449.17 283.612 449.17 299.664C449.178 300.374 449.143 301.084 449.065 301.79L412.769 301.786ZM412.98 294.344H435.002C434.576 287.644 430.414 283.712 424.253 283.712C418.302 283.712 413.833 287.539 412.98 294.344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.265 324.429L445.766 275.635H461.094L471.844 306.571H472.05L482.8 275.635H497.918L476.528 324.429H467.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.784 301.786V302.423C508.784 309.971 513.891 314.755 520.81 314.755C525.6 314.755 529.114 312.308 531.881 308.06L532.729 307.739L543.906 312.097C539.437 320.602 531.454 325.386 520.383 325.386C504.527 325.386 494.305 314.544 494.305 299.555C494.305 284.35 504.857 273.613 520.066 273.613C534.858 273.613 545.186 283.608 545.186 299.66C545.194 300.37 545.158 301.08 545.08 301.786H508.784ZM508.996 294.344H531.018C530.591 287.645 526.43 283.713 520.268 283.713C514.318 283.713 509.849 287.539 508.996 294.344Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16533_52178",
    x1: 153.125,
    y1: 238.804,
    x2: 251.639,
    y2: 238.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37C5BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3AC4BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#44C3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#54C0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6CBC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8AB783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AFB168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DAAA48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A635"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16533_52178",
    x1: 54.8203,
    y1: 300.008,
    x2: 153.132,
    y2: 300.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C5BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16533_52178",
    x1: 54.8203,
    y1: 361.061,
    x2: 153.132,
    y2: 361.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C5BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16533_52178",
    x1: 153.125,
    y1: 299.866,
    x2: 251.639,
    y2: 299.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37C5BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#42C3B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#60BEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#90B67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D2AC4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A635"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16533_52178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16533_52178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 490,
    height: 225,
    fill: "white",
    transform: "translate(55 187)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeve);
export default __webpack_public_path__ + "static/media/weeve.30ec43b74ca87584eee5f524b6ced68d.svg";
export { ForwardRef as ReactComponent };